<ng-container *transloco="let t">
	<div class="relative rounded-xl bg-white p-8 shadow dark:bg-forum-400">
		<h1 class="mb-4 font-headline text-lg font-semibold leading-tight text-gray-1000 dark:text-white">{{ t('UI.new_version') }}</h1>
		<p class="text-base text-gray-700 dark:text-gray-400">{{ t('UI.new_version_info') }}</p>
		<div class="mt-8 flex flex-row justify-end">
			<button
				(click)="reload()"
				class="rounded-xl bg-blue-500 px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 ease-in-out hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-400 dark:hover:bg-blue-500 dark:focus:ring-offset-forum-400"
			>
				Reload
			</button>
		</div>
	</div>
</ng-container>
